import axios, {
  type InternalAxiosRequestConfig,
  type ResponseType
} from 'axios';
import { environmentData } from '../utils/baseInfo';
import { REGION_MODE } from '../utils/config';
import { isMobile, logEvent } from '../utils/index';

interface ApiConfig {
  env: string;
  lang: string;
  country?: string;
}
// 增加自定义超时timeout 响应responseType
export interface RequestConfig {
  url: string;
  baseURL?: string;
  method?: 'get' | 'post';
  data?: {};
  headers?: {};
  timeout?: any;
  responseType?: ResponseType;
  onDownloadProgress?: (progressEvent: any) => void;
}
const TimeOut = 15000;
const URL = {
  test: {
    cn: 'https://cn-test3-oms-gateway.segwaydiscovery.com/portal/api/',
    us: 'https://sg-test1-oms-gateway.segwaydiscovery.com/portal/api/'
  },
  grey: {
    cn: 'https://cn-grey-oms-gateway.segwaydiscovery.com/portal/api/',
    us: 'https://sg-grey-oms-gateway.segwaydiscovery.com/portal/api/'
  },
  prod: {
    us: 'https://eu-oms-gateway.segwaydiscovery.com/portal/api/', // 正式海外环境
    cn: 'https://cnnx-omsgw.ninebot.com/portal/api/' // 正式国内环境
  }
};

// 请求函数
export function httpRequest(params: RequestConfig) {
  return new Promise((resolve, reject) => {
    axios(params)
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });
}

axios.interceptors.request.use((config: any) => {
  config = handleRequestHeader(config);
  config = handleAuth(config);
  return config;
});

function blobToArrayBuffer(blob: any) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsArrayBuffer(blob);
  });
}

axios.interceptors.response.use(
  response => {
    const resData: any = response.data;
    if (response.status !== 200) {
      return Promise.reject(resData);
    }
    if (
      resData.data === null ||
      resData.data === 'undefined' ||
      resData.data === ''
    ) {
      logEvent({
        data: response.config.data || response.config.params,
        url: response.request.responseURL,
        errorMsg: 'data属性值不存在'
      });
    }
    if (resData && resData.code === 0) {
      return Promise.resolve(resData);
    } else {
      if (response.config.responseType === 'blob') {
        // const blobData: any = new Blob([resData], {
        //   type: response.headers['content-type']
        // });
        // const arrayBuffer = await blobToArrayBuffer(blob);

        return blobToArrayBuffer(resData).then((buffer: any) => {
          try {
            const decoder = new TextDecoder('utf-8');
            const decoded = decoder.decode(new Uint8Array(buffer));
            const errorData = JSON.parse(decoded);
            return Promise.reject(errorData);
          } catch {
            return Promise.resolve(resData);
          }
        });
      }

      logEvent({
        data: response.config.data || response.config.params,
        url: response.request.responseURL,
        errorMsg: resData.msg
      });
      return Promise.reject(resData);
    }

    return resData;
  },
  (error: any) => {
    logEvent({
      data: error.config.data || error.config.params,
      url: error.request.responseURL || error.config.baseURL + error.config.url,
      errorMsg: error.message,
      isTimeout:
        error.code === 'ECONNABORTED' || error.message.includes('timeout')
          ? true
          : false
    });
    return Promise.reject(error);
  }
);

function handleRequestHeader(config: InternalAxiosRequestConfig<any>) {
  if (!config['timeout']) config['timeout'] = TimeOut;
  if (!config?.baseURL) {
    config['baseURL'] = URL[environmentData.env as keyof object][REGION_MODE];
  }

  if (config.method === 'get') {
    config.params = config.data;
    config.data = null;
  }
  return config;
}

function handleAuth(config: any) {
  const header = {
    language:
      environmentData.requestLang || (REGION_MODE === 'us' ? 'en' : 'zh'),
    country: environmentData.requestCountry?.toUpperCase(),
    platform: 'web',
    platform_ver: '1.0.0',
    env: environmentData.env || '',
    reqId: getRandomString(20),
    'x-forward-origin': 'pc'
  };
  if (process.client) {
    const isApp = () => navigator.userAgent.toLowerCase().includes('segway');
    let origin: string = '';
    if (isMobile()) {
      isApp() ? (origin = 'app') : (origin = 'mobile');
    } else {
      origin = 'pc';
    }
    header['x-forward-origin'] = origin;
  }
  config.headers = {
    ...header,
    ...config.headers
  };
  return config;
}

function getRandomString(length: number) {
  var result = '';
  var characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

// function handleNetworkError(errStatus: any) {
//   let errMessage = '未知错误';
//   if (errStatus) {
//     switch (errStatus) {
//       case 400:
//         errMessage = '错误的请求';
//         break;
//       case 401:
//         errMessage = '未授权，请重新登录';
//         break;
//       case 403:
//         errMessage = '拒绝访问';
//         break;
//       case 404:
//         errMessage = '请求错误,未找到该资源';
//         break;
//       case 405:
//         errMessage = '请求方法未允许';
//         break;
//       case 408:
//         errMessage = '请求超时';
//         break;
//       case 500:
//         errMessage = '服务器端出错';
//         break;
//       case 501:
//         errMessage = '网络未实现';
//         break;
//       case 502:
//         errMessage = '网络错误';
//         break;
//       case 503:
//         errMessage = '服务不可用';
//         break;
//       case 504:
//         errMessage = '网络超时';
//         break;
//       case 505:
//         errMessage = 'http版本不支持该请求';
//         break;
//       default:
//         errMessage = `其他连接错误 --${errStatus}`;
//     }
//   } else {
//     errMessage = `无法连接到服务器！`;
//   }

//   return errMessage;
// }
